import useScrollReveal from "@/hooks/useScrollReveal";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import EntryPortal from "./components/EntryPortal";
import ArchiveGrid from "./components/ArchiveGrid";
import Timeline from "./components/Timeline";
import HowItWorks from "./components/HowItWorks";
import TrustSection from "./components/TrustSection";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";
import Footer from "./components/Footer";

export default function Home() {
  useScrollReveal();

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <EntryPortal />
        <ArchiveGrid />
        <Timeline />
        <HowItWorks />
        <TrustSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}